import React, { useEffect, useState } from "react";
import { Context, Hooks } from "@xt/xtbase";
const { XtContext, XtAuth } = Context;
const { useTranslation } = Hooks;
import styles from "./index.module.less";
import { useStore } from "@/models";
import { observer } from "mobx-react-lite";
import MarketList from "../MarketList";
import { getRecommendedFiatCodesFromList } from "@/utils/fiatMarket";

// Tab 顺序：Fiat-M, Usdt-M（optional 需登录，排最前）；Spot tab 已注释；AI tab 已关闭
const getMarketTypeAry = (t, showFiatTab, loginStatus) => {
  const list = [
    { key: "optional", label: t("trade.favorites"), isLogin: true },
    { key: "fiat-m", label: t("market.tabFiatM") },
    { key: "usdt-m", label: t("market.tabUsdtM") },
    // { key: "spot", label: "Spot" },
    // { key: "ai", label: "AI" },
  ];
  return list.filter((item) => {
    if (item.isLogin && loginStatus != 1) return false;
    if (item.key === "fiat-m" && !showFiatTab) return false;
    return true;
  });
};

const MarketContent = (props) => {
  const t = useTranslation();
  const [appState] = React.useContext(XtContext);
  const { loginStatus } = appState;
  const { fund } = useStore();

  const [tab, setTab] = useState("");
  const [showFiatTab, setShowFiatTab] = useState(null);
  const [activeFiatCodes, setActiveFiatCodes] = useState([]);
  const [subTab, setSubTab] = useState("crypto");

  const marketTypeAry = getMarketTypeAry(t, showFiatTab === true, loginStatus);

  const onClick = (key) => {
    if (tab !== key) {
      setTab(key);
    }
  };

  const onSubTabChange = (key) => {
    if (subTab !== key) setSubTab(key);
  };

  useEffect(() => {
    const fiatCodes = getRecommendedFiatCodesFromList(fund?.recommendedCurrencyList);
    setShowFiatTab(fiatCodes.length > 0);
    setActiveFiatCodes(fiatCodes);
  }, [fund?.recommendedCurrencyList, loginStatus]);

  useEffect(() => {
    if (showFiatTab === null) return;
    const defaultTab = showFiatTab ? "fiat-m" : "usdt-m";
    let nextTab = defaultTab;
    if (typeof window !== "undefined") {
      const raw = (window.location.hash || "").replace(/^#/, "").toLowerCase();
      if (raw === "optional" && loginStatus === 1) nextTab = "optional";
      else if (raw === "fiat-m" && showFiatTab === true) nextTab = "fiat-m";
      else if (raw === "usdt-m") nextTab = "usdt-m";
    }
    setTab(nextTab);
  }, [showFiatTab, loginStatus]);

  const showSecondaryTabs = tab === "fiat-m" || tab === "usdt-m" || tab === "optional";

  return (
    <div className={styles["trade-market"]}>
      <div className={styles["parent-tabs-view"]}>
        <div className={styles["market-parent-tabs"]} role="tablist">
          {marketTypeAry.map((item, index) => (
            <div
              key={"market-parent-tabs-" + index}
              role="tab"
              tabIndex={0}
              aria-selected={tab === item.key}
              className={`${styles["market-parent-tab"]} ${
                tab === item.key ? styles["market-parent-tab--active"] : ""
              }`}
              onClick={() => onClick(item.key)}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault();
                  onClick(item.key);
                }
              }}
            >
              {item.label}
            </div>
          ))}
        </div>
      </div>
      {showSecondaryTabs && (
        <div className={styles["secondary-tabs-wrap"]}>
          <div className={styles["secondary-tabs"]}>
            <div
              onClick={() => onSubTabChange("crypto")}
              className={`${styles["secondary-tab"]} ${subTab === "crypto" ? styles["secondary-tab--active"] : ""}`}
            >
              {t("market.subTabCrypto") || "Crypto"}
            </div>
            <div
              onClick={() => onSubTabChange("stocks")}
              className={`${styles["secondary-tab"]} ${subTab === "stocks" ? styles["secondary-tab--active"] : ""}`}
            >
              {t("market.subTabStocks") || "Stocks"}
            </div>
            <div
              onClick={() => onSubTabChange("commodities")}
              className={`${styles["secondary-tab"]} ${subTab === "commodities" ? styles["secondary-tab--active"] : ""}`}
            >
              {t("market.subTabCommodities") || "Commodities"}
            </div>
          </div>
        </div>
      )}
      {tab && (
        <XtAuth
          renderLogin={() => (
            <MarketList
              marketType={tab}
              activeFiatCodes={activeFiatCodes}
              subTab={showSecondaryTabs ? subTab : ""}
              showFiatTab={showFiatTab === true}
              onGoToCryptoTab={(preferFiat) => {
                const target = preferFiat && showFiatTab ? "fiat-m" : "usdt-m";
                setTab(target);
                setSubTab("crypto");
              }}
            />
          )}
          renderNotLogin={() => (
            <MarketList
              marketType={tab}
              activeFiatCodes={activeFiatCodes}
              subTab={showSecondaryTabs ? subTab : ""}
              showFiatTab={showFiatTab === true}
              onGoToCryptoTab={(preferFiat) => {
                const target = preferFiat && showFiatTab ? "fiat-m" : "usdt-m";
                setTab(target);
                setSubTab("crypto");
              }}
            />
          )}
        />
      )}
    </div>
  );
};
export default observer(MarketContent);
